
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptGrid extends _Ext.GridBase<JobWorkReceiptRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkReceipt'; }
        protected getDialogType() { return JobWorkReceiptDialog; }
        protected getIdProperty() { return JobWorkReceiptRow.idProperty; }
        protected getInsertPermission() { return JobWorkReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReceiptRow.localTextPrefix; }
        protected getService() { return JobWorkReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(70);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<JobWorkReceiptRow>{
                VoucherNo: voucherNo,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 70,
                EmployeeId: 0,
                TransDate: now.toString(),
                CompanyId:  userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                CurrencyId:  userDefinition.CurrencyId,
                ExchRate: userDefinition.exchangerate,
            });
        }
    }
}